(function () {
  if (window.__collectionEmptyFallback) return;
  window.__collectionEmptyFallback = true;

  function checkEmptyCollection() {
    const grid = document.querySelector('#ProductGrid');
    const fallback = document.querySelector('#FilterEmptyFallback');

    if (!grid || !fallback) return;

    // Check Fillter
    const hasFilter =
      window.location.search.length > 0 ||
      window.location.pathname.split('/collections/')[1]?.split('/').length > 1;

    if (!hasFilter) {
      fallback.style.display = 'none';
      return;
    }

    // Check prodcut item
    const products = grid.querySelectorAll('.grid-product');

    if (products.length === 0) {
      fallback.style.display = 'block';
    } else {
      fallback.style.display = 'none';
    }
  }

  // First Loop
  document.addEventListener('DOMContentLoaded', checkEmptyCollection);

  // Block AJAX filter reload (Impulse)
  const target =
    document.querySelector('#CollectionAjaxContent') ||
    document.querySelector('#ProductGrid');

  if (target) {
    const observer = new MutationObserver(checkEmptyCollection);

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }
})();

/****** Collection Countdown *******/
function initCollectionCountdown() {
  const countdowns = document.querySelectorAll(
    ".collection-countdown[data-countdown-timestamp]"
  );

  countdowns.forEach((countdown) => {
    if (countdown.dataset.countdownInitialized === "true") return;

    const releaseTimestamp = Number(
      countdown.dataset.countdownTimestamp
    );

    if (!releaseTimestamp || Number.isNaN(releaseTimestamp)) return;

    const daysEl = countdown.querySelector("[data-countdown-days]");
    const hoursEl = countdown.querySelector("[data-countdown-hours]");
    const minutesEl = countdown.querySelector("[data-countdown-minutes]");
    const secondsEl = countdown.querySelector("[data-countdown-seconds]");

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    countdown.dataset.countdownInitialized = "true";

    const padNumber = (number) => {
      return String(number).padStart(2, "0");
    };

    const updateCountdown = () => {
      const distance = releaseTimestamp - Date.now();

      if (distance <= 0) {
        clearInterval(intervalId);
        window.location.reload();
        return;
      }

      const days = Math.floor(
        distance / (1000 * 60 * 60 * 24)
      );

      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );

      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) /
        (1000 * 60)
      );

      const seconds = Math.floor(
        (distance % (1000 * 60)) /
        1000
      );

      daysEl.textContent = padNumber(days);
      hoursEl.textContent = padNumber(hours);
      minutesEl.textContent = padNumber(minutes);
      secondsEl.textContent = padNumber(seconds);
    };

    updateCountdown();

    const intervalId = window.setInterval(
      updateCountdown,
      1000
    );
  });
}

document.addEventListener(
  "DOMContentLoaded",
  initCollectionCountdown
);

document.addEventListener(
  "shopify:section:load",
  initCollectionCountdown
);



/// Mobile Navigation
(function () {
  if (window.__jscMobileMenuV2) return;
  window.__jscMobileMenuV2 = true;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('#NavDrawer [data-mobile-menu-next]');
    if (openBtn) {
      e.preventDefault();

      var targetId = openBtn.getAttribute('data-mobile-menu-next');
      var targetPanel = document.getElementById(targetId);

      if (targetPanel) {
        targetPanel.classList.add('is-active');
        targetPanel.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var backBtn = e.target.closest('#NavDrawer [data-mobile-menu-back]');
    if (backBtn) {
      e.preventDefault();

      var currentPanel = backBtn.closest('.jsc-mobile-menu__level--panel');
      if (currentPanel) {
        currentPanel.classList.remove('is-active');
        currentPanel.setAttribute('aria-hidden', 'true');

        var trigger = document.querySelector('#NavDrawer [data-mobile-menu-next="' + currentPanel.id + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
      return;
    }

    var resetBtn = e.target.closest('#NavDrawer [data-mobile-menu-reset], #NavDrawer .js-drawer-close');
    if (resetBtn) {
      var panels = document.querySelectorAll('#NavDrawer .jsc-mobile-menu__level--panel.is-active');
      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });

      var triggers = document.querySelectorAll('#NavDrawer [data-mobile-menu-next][aria-expanded="true"]');
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();

  document.addEventListener('DOMContentLoaded', function () {
    const dropdowns = document.querySelectorAll('.language-dropdown');

    dropdowns.forEach(function (dropdown) {
      const toggle = dropdown.querySelector('.language-dropdown__toggle');

      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        dropdown.classList.toggle('is-open');
      });
    });

    document.addEventListener('click', function () {
      dropdowns.forEach(function (dropdown) {
        dropdown.classList.remove('is-open');
      });
    });
  });


/*** Jibbizt Drawer  *****/

const jibbitzCache = {};

/* =========================
   INIT JIBBITZ PRODUCT IMAGES
========================= */
function initJibbitzImages(container) {
  if (!container) return;

  requestAnimationFrame(() => {

    container
      .querySelectorAll('image-element[data-aos="image-fade-in"]')
      .forEach((el) => {
        el.classList.add('aos-init', 'aos-animate');

        el.style.opacity = '1';
        el.style.visibility = 'visible';
        el.style.transform = 'none';
      });

  });
}

/* =========================
   OPEN / CLOSE DRAWER
========================= */
document.addEventListener('click', async (e) => {

  const trigger = e.target.closest('.js-open-jibbitz-drawer');

  /* =========================
     OPEN DRAWER
  ========================== */
  if (trigger) {

    e.preventDefault();

    const handle = trigger.dataset.jibbitzHandle;

    const drawer = document.querySelector('#JibbitzDrawer');
    const content = drawer?.querySelector('.jibbitz-drawer__content');

    if (!handle || !drawer || !content) return;

    drawer.hidden = false;

    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });

    document.body.style.overflow = 'hidden';

    /* =========================
       CACHE
    ========================== */
    if (jibbitzCache[handle]) {

      content.innerHTML = jibbitzCache[handle];

      initJibbitzImages(content);

      return;
    }
    /* =========================
       LOADING
    ========================== */
content.innerHTML = `
  <div class="jibbitz-loading-grid">

    ${Array(6).fill(`
      <div class="jibbitz-loading-card">

        <div class="qv-skeleton jibbitz-skeleton--image"></div>

        <div class="jibbitz-loading-card__info">
          <div class="qv-skeleton jibbitz-skeleton--title"></div>
          <div class="qv-skeleton jibbitz-skeleton--title jibbitz-skeleton--title-short"></div>
          <div class="qv-skeleton jibbitz-skeleton--price"></div>
        </div>

      </div>
    `).join('')}

  </div>
`;

    /* =========================
       FETCH COLLECTION
    ========================== */
    try {

      const response = await fetch(
        `/collections/${handle}?view=jibbitz-drawer`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();


      /* CACHE */
      jibbitzCache[handle] = html;


      /* INSERT CONTENT */
      content.innerHTML = html;


      /* FIX IMAGE ELEMENT / AOS */
      initJibbitzImages(content);


    } catch (error) {

      console.error('Jibbitz Drawer Error:', error);

      content.innerHTML = `
        <p>Unable to load Jibbitz™ Charms.</p>
      `;
    }

    return;
  }

  /* =========================
     CLOSE DRAWER
  ========================== */
  if (
    e.target.closest('.jibbitz-drawer__close') ||
    e.target.closest('.jibbitz-drawer__overlay')
  ) {

    const drawer = document.querySelector('#JibbitzDrawer');

    if (!drawer) return;

    drawer.classList.remove('is-open');

    setTimeout(() => {
      drawer.hidden = true;
    }, 350);

    document.body.style.overflow = '';
  }

});

///**** Product Detail ---- PDP ******/

(function () {
  function initProductAccordion(root) {
    if (!root || root.dataset.nativeAccordionReady === 'true') return;

    root.dataset.nativeAccordionReady = 'true';

    root.addEventListener('click', function (event) {
      const button = event.target.closest('button[data-target^="#collapse"]');

      if (!button || !root.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      const selector = button.getAttribute('data-target');
      if (!selector) return;

      const target = root.querySelector(selector);
      if (!target) return;

      const isOpen = target.classList.contains('show');

      // ปิดอันอื่น
      root.querySelectorAll('.collapse.show').forEach(function (panel) {
        if (panel === target) return;

        panel.classList.remove('show');

        const otherButton = root.querySelector(
          'button[data-target="#' + panel.id + '"]'
        );

        if (otherButton) {
          otherButton.classList.add('collapsed');
          otherButton.setAttribute('aria-expanded', 'false');
        }
      });

      // เปิด / ปิดตัวที่กด
      if (isOpen) {
        target.classList.remove('show');
        button.classList.add('collapsed');
        button.setAttribute('aria-expanded', 'false');
      } else {
        target.classList.add('show');
        button.classList.remove('collapsed');
        button.setAttribute('aria-expanded', 'true');
      }
    }, true);
  }

  function initAllProductAccordions() {
    document
      .querySelectorAll('#ProductOption')
      .forEach(initProductAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllProductAccordions
    );
  } else {
    initAllProductAccordions();
  }

  // Shopify Theme Editor
  document.addEventListener(
    'shopify:section:load',
    initAllProductAccordions
  );

  // Quick View
  document.addEventListener(
    'quickview:loaded',
    initAllProductAccordions
  );
})();